export const editableProps = {
    spellCheck: false,
    autoFocus: false,
    readOnly: false,
    placeholder: 'Type…',
};
export const readOnlyProps = {
    spellCheck: false,
    autoFocus: false,
    readOnly: true,
    placeholder: '',
};
//# sourceMappingURL=editableProps.js.map